import {
  CREATE_ORDER_DELIVERY_SCHEDULE,
  UPDATE_ORDER_DELIVERY_SCHEDULE,
  ORDER_DELIVERY_SCHEDULE_REQUEST,
  ORDER_DELIVERY_SCHEDULE_REQUEST_FAILURE,
  ORDER_DELIVERY_SCHEDULE_REQUEST_SUCCESS,
} from "../types/order-delivery-schedule-types";

const initialState = {
  orderDeliverySchedules: [],
  loading: false,
  error: null,
};

const orderDeliveryScheduleReducer = (state = initialState, action) => {
  switch (action.type) {
    case ORDER_DELIVERY_SCHEDULE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case CREATE_ORDER_DELIVERY_SCHEDULE: {
      return {
        ...state,
        orderDeliverySchedules: [action.payload, ...state.orderDeliverySchedules],
        loading: false,
        error: null
      };
    }
    case UPDATE_ORDER_DELIVERY_SCHEDULE: {
      const orderDeliverySchedulesData = state.orderDeliverySchedules.slice(0);
      const uIndex = orderDeliverySchedulesData.findIndex((data) => data.id === action.payload.id);
      orderDeliverySchedulesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        orderDeliverySchedules: [ ...orderDeliverySchedulesData ],
        loading: false,
        error: null
      };
    }
    case ORDER_DELIVERY_SCHEDULE_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case ORDER_DELIVERY_SCHEDULE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default orderDeliveryScheduleReducer;
